[
  {
    "id": "SR-M8-KANGOEROE-V01",
    "module": "SpellingRegel",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-KANGOEROE",
    "conceptId": "tricky_vowel_endings",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "kangoeroe",
      "kangeroe",
      "kangoeroo",
      "kangoerou"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'kangoeroe'. Let op de klinkers: a-oe-oe. Het woord eindigt op '-oe', niet op '-oo' of '-ou'.",
    "distractorExplanations": {
      "1": "Hier ontbreekt de eerste 'oe'. Het woord heeft twee keer 'oe': kang-oe-r-oe.",
      "2": "Het woord eindigt op '-oe', niet op '-oo'. Dit is geen Engelse spelling.",
      "3": "Het woord eindigt op '-oe', niet op '-ou'. Denk aan de klank: oe zoals in 'koe'."
    }
  },
  {
    "id": "SR-M8-PORTEMONNEE-V01",
    "module": "SpellingRegel",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_frans",
    "familyId": "SR-WEETWOORD-PORTEMONNEE",
    "conceptId": "french_loanword_spelling",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "portemonnee",
      "portemonee",
      "portomonee",
      "portemonnaie"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'portemonnee'. Dit is de vernederlandste spelling van het Franse woord. Onthoud: porte-mon-nee (dubbele 'n', dubbele 'e').",
    "distractorExplanations": {
      "1": "Hier ontbreekt een 'n'. Het woord heeft dubbel-n: porte-mon-nee.",
      "2": "De eerste lettergreep is 'porte', niet 'porto'. En er ontbreekt een 'n'.",
      "3": "Dit is de originele Franse spelling. In het Nederlands schrijven we 'portemonnee'."
    }
  },
  {
    "id": "SR-M8-INTERESSANT-V01",
    "module": "SpellingRegel",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-INTERESSANT",
    "conceptId": "tricky_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "interessant",
      "intressant",
      "interresant",
      "interessand"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'interessant'. Het heeft één 'r' en een dubbele 's'. Onthoud: inte-res-sant (de dubbele letter is de 's', niet de 'r'). Het eindigt op '-ant', niet '-and'.",
    "distractorExplanations": {
      "1": "Hier ontbreekt de 'e' na 'int'. Het woord is: in-te-res-sant.",
      "2": "Hier staat een dubbele 'r', maar het woord heeft maar één 'r' en juist een dubbele 's'.",
      "3": "Het woord eindigt op '-ant' met een 't', niet op '-and' met een 'd'. Je kunt dit controleren door het te verlengen: interessante."
    }
  },
  {
    "id": "SR-M8-ACCOMMODATIE-V01",
    "module": "SpellingRegel",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-ACCOMMODATIE",
    "conceptId": "tricky_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "accommodatie",
      "accomodatie",
      "acomodatie",
      "akkommodatie"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'accommodatie'. Het heeft een dubbele 'c' én een dubbele 'm'. Onthoud: ac-com-mo-da-tie (twee keer een dubbele medeklinker).",
    "distractorExplanations": {
      "1": "Hier ontbreekt een 'm'. Het woord heeft zowel dubbel-c als dubbel-m.",
      "2": "Hier ontbreken een 'c' en een 'm'. Beide medeklinkers zijn dubbel.",
      "3": "De 'cc' wordt niet als 'kk' geschreven. Het is een Latijns leenwoord met 'cc'."
    }
  },
  {
    "id": "SR-M8-BARBECUE-V01",
    "module": "SpellingRegel",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-BARBECUE",
    "conceptId": "english_loanword_spelling",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is correct gespeld?",
    "options": [
      "barbecue",
      "barbeque",
      "barbaque",
      "barbekjoe"
    ],
    "correctAnswer": 0,
    "explanation": "Het juiste woord is 'barbecue'. Dit Engels leenwoord schrijf je met '-cue' aan het eind, niet met '-que'. Onthoud: bar-be-cue.",
    "distractorExplanations": {
      "1": "De uitgang is '-cue', niet '-que'. Hoewel 'que' Frans lijkt, is de juiste Engelse spelling '-cue'.",
      "2": "De middelste lettergreep is 'be', niet 'ba'. En de uitgang is '-cue'.",
      "3": "Dit is een fonetische schrijfwijze. Engelse leenwoorden behouden hun originele spelling."
    }
  }
]